module.exports = __webpack_public_path__ + "images/obogrev-morozilnikov.de025ad2.jpg";